<template>
<v-container fluid fill-height class="pa-0">
    <v-layout v-if="errorMessage">
        <v-flex>
            <v-alert 
                :value="true" 
                outline 
                type="error">
                <span>{{ errorMessage }}</span>
            </v-alert>
        </v-flex>
    </v-layout>
    <loading v-if="loading"></loading>
    <v-layout v-if="!loading && !errorMessage">
        <v-flex>
            <PlantConfigurationUnitsTable :data="plantUnits" @edit="openEdit"></PlantConfigurationUnitsTable>
        </v-flex>
    </v-layout>
    <PlantConfigurationUnitsAddEdit
        v-if="showAddEditDialog"
        :plantID="plantID"
        :show="showAddEditDialog"
        :originalItem="editedItem"
        @close="onAddEditClose"
        :productCategories="productCategories"
        :units="units"
        :recordingModes="recordingModes"
        :plantUnits="plantUnits"
        >
    </PlantConfigurationUnitsAddEdit>
</v-container>
</template>

<script>
import BaseAPI from "@/api/baseApi";
import plantConfigurationApi from '@/api/plantConfigurationApi'
import Loading from '@/components/generic/Loading.vue';
import PlantConfigurationUnitsTable from '@/components/plants/configuration/PlantConfigurationUnitsTable.vue'
import PlantConfigurationUnitsAddEdit from '@/components/plants/configuration/PlantConfigurationUnitsAddEdit.vue'

export default {
    props: {
        plantID: {
            required: true,
            type: Number
        }
    },
    components: {
        Loading,
        PlantConfigurationUnitsTable,
        PlantConfigurationUnitsAddEdit
    },
    data() {
        return {
            errorMessage: null,
            loading: false,
            showAddEditDialog: false,
            editedItem: null,
            plantUnits: [],
            units:[],
            productCategories:[],
            recordingModes:[]
        };
    },
    methods: {
        async loadData() {
            try {
                 this.loading = true;

                this.plantUnits = await plantConfigurationApi.getPlantUnits(this.plantID);

                this.units = await plantConfigurationApi.getActiveUnits();
                this.productCategories = await plantConfigurationApi.getActiveProductCategories();
                this.recordingModes = await plantConfigurationApi.getRecordingModes();
            }
            catch (err) {
                this.errorMessage = await BaseAPI.parseHttpRequestError(err);

                throw err;
            }
            finally {
                this.loading = false;
            }
        },
        async openEdit(item) {
            this.editedItem = item;
            this.showAddEditDialog = true;
        },
        async onAddEditClose(saved) {
            this.showAddEditDialog = false;            

            if (saved === true) {
                await this.loadData();
            }
        }
    },
    created() {
        this.loadData();
    }
}
</script>

<style>

</style>
